module.exports = __webpack_public_path__ + "img/download.1fc22f13.jpg";